import React, { useState } from 'react'
import { Alert, Button, Col, Form, Icon, Input, Radio, Row, Tag } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../../utils/hooks'
import _, { isNull } from 'lodash'

const CoinUpdate = ({ form, onOk, onCancel, heroId, coin }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const name = localStorage.getItem('user-name')
        const data = {
          heroId: heroId,
          amount: values.amount,
          transactionFlag: values.transactionFlag,
          transactionAction: name + " [ADMIN]"
        }
        if (coin < values.amount && values.transactionFlag == 0) {
          alert('Not enough Coin');
        } else {
          onOk(data)
        }
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Amount">
        {getFieldDecorator(`amount`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(<Input type="number" min="1" />)}
      </Form.Item>
      <Form.Item label="">
        {getFieldDecorator(`transactionFlag`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
            <Radio value={1}>
              <Tag color='Green'>
                +
              </Tag>Coin</Radio>
            <Radio value={0}>
              <Tag color='Red'>
                -
              </Tag> Coin</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedCoinUpdate = Form.create({ name: 'DocUpdate' })(CoinUpdate)
export default WrappedCoinUpdate